<script>
    import R, {LOADER} from "../lib/requests";
    import {PASSWORD_TIP} from "../lib/constants.js";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import Notifier from "../stores/notifier.js";
    import {setFocusTo} from "../lib/lib.js";
    import LastNameControl from "../components/controls/LastNameControl.svelte";
    import BirthdayControl from "../components/controls/BirthdayControl.svelte";
    import PhoneControl from "../components/controls/PhoneControl.svelte";
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import PageInfo from "../components/pages/PageInfo.svelte";

    let account = null;
    let countries = null;
    let changePassword = false;

    const load = () => {
        const onSuccess = result => {
            account = result.account;
            countries = result.countries;
        }

        const onFailure = err => {
        };

        R.handle(R.member.details, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {
        const onSuccess = result => {
            delete (account.new_password);
            changePassword = false;
            Notifier.showMessage("Your account has been updated");
        }

        const onFailure = err => {
            if (err.code === 'same_object_identifier') {
                Alert.warning("Update Account", "There is already a member account with the email you provided!", () => setFocusTo('accountEmail'));
                return;
            }

            if (err.code === 'password_field_invalid') {
                Alert.warning("Update Account", PASSWORD_TIP, () => setFocusTo('accountPassword'));
                return;
            }

            Alert.warning("Update Account", err.message);
        };

        R.handle(R.member.edit, account, onSuccess, onFailure, LOADER.POPUP);
    }

    const togglePassword = () => {
        changePassword = !changePassword;
        if (!changePassword) {
            delete (account.new_password);
        }
    }

    if ($user.token) {
        load();
    }
</script>

<div class="page-header solid">
    <h1>My Account</h1>
</div>
<div class="page page-padding">

    {#if !$user.token}
        <PageInfo icon="user" message="You need to sing in to your account!" showLogin/>
    {/if}
    {#if account}
        <div class="panel-simple account-panel box-shadow rounded panel-pad">
            <form on:submit|preventDefault|stopPropagation="{ save }">
                <div class="row">
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Last name *</label>
                        <LastNameControl bind:abbr="{ account.abbr }" bind:lastname="{ account.lastname }" required/>
                    </div>
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">First name *</label>
                        <input type="text" class="form-control" bind:value="{ account.firstname}" required>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Birthday *</label>
                        <BirthdayControl bind:value="{ account.birthday}" required/>
                    </div>
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Nationality *</label>
                        <select class="form-select" bind:value="{ account.country_id }" required>
                            <option value="" disabled>select</option>
                            {#each countries as country}
                                <option value="{ country.id }">{ country.name }</option>
                            {/each}
                        </select>
                    </div>

                    <div class="col-md-6 col-12 lg-3 form-group">
                        <label class="text-gray small">Phone *</label>
                        <PhoneControl bind:value="{ account.phone }" required/>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Address</label>
                        <input type="text" class="form-control" bind:value="{ account.address}">
                    </div>
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">City</label>
                        <input type="text" class="form-control" bind:value="{ account.city}">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Zip</label>
                        <input type="text" class="form-control" bind:value="{ account.zip}">
                    </div>
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Passport Id</label>
                        <input type="text" class="form-control" bind:value="{ account.passport_id}" autocomplete="off">
                    </div>
                </div>
                <hr>
                <div class="row align-items-center">
                    <div class="col-md-6 col-12 form-group">
                        <label class="text-gray small">Email *</label>
                        <input type="email" class="form-control" id="accountEmail" bind:value="{ account.email }"
                               autocomplete="off" required>
                    </div>
                    {#if !changePassword}
                        <div class="col-md-6 form-group">
                            <div class="btn btn-link mt-md-4" on:click="{ togglePassword }">
                                change my password
                            </div>
                        </div>
                    {/if}
                </div>

                {#if changePassword}
                    <p class="small text-gray mb-1">
                        { PASSWORD_TIP }
                    </p>
                    <div class="row align-items-center">
                        <div class="col-md-6 col-12 form-group">
                            <label class="text-gray small">New password</label>
                            <PasswordControl id="accountPassword" bind:value="{ account.new_password}" required/>
                        </div>
                        <div class="col-md-6 col-12 form-group">
                            <div class="btn btn-link mt-md-4" on:click="{ togglePassword }">
                                do not change my password
                            </div>
                        </div>
                    </div>
                {/if}

                <div class="form-check form-group mt-4">
                    <input class="form-check-input" type="checkbox" value="" id="checkNotifications"
                           checked="{ account.allow_notifications == 1 }"
                           on:click={ () => account.allow_notifications = account.allow_notifications == 1 ? 0 : 1 }>
                    <label class="form-check-label" for="checkNotifications">
                        I wish to receive newsletters
                    </label>
                </div>

                <hr class="mb-4">
                <div class="text-end">
                    <button class="btn btn-primary rounded px-4">Update</button>
                </div>
            </form>
        </div>
    {/if}
</div>

<style>
    .account-panel {
        max-width: 700px;
    }
</style>